<template>
  <div class="animate__animated animate__fadeIn">
    <h4 class="font-weight-bold">Outras Características</h4>
    <form @submit.prevent="submit" ref="addItem">
      <div class="row mt-3">
        <form-select
          v-model="parc_mds"
          label="Grupos Populacionais Tradicionais e Específicos (GPTE)"
          :multiple="true"
          :itens="$root.arrays.parc_mds"
        />

        <form-select
          v-model="caracteristicas.ind_risco_violacao_direito"
          grid="12"
          label="A família está em risco de violação de direito?"
          :itens="$root.arrays.pergunta"
        />

        <form-select
          v-model="caracteristicas.familia_indigena"
          grid="6"
          label="A família é indígena?"
          :itens="$root.arrays.pergunta"
        />

        <form-input
          v-model="caracteristicas.nome_povo_indigena"
          grid="6"
          label="Nome do povo indígena"
        />

        <form-select
          v-model="caracteristicas.indigena_reside"
          grid="6"
          label="Reside em reserva indígena"
          :itens="$root.arrays.pergunta"
        />

        <form-input
          v-model="caracteristicas.nome_reserva_indigena"
          grid="6"
          label="Nome da reserva indígena"
        />

        <form-select
          v-model="caracteristicas.familia_quilombola"
          grid="6"
          label="A família é quilombola?"
          :itens="$root.arrays.pergunta"
        />

        <form-input
          v-model="caracteristicas.nome_comunidade_quilombola"
          grid="6"
          label="Nome da comunidade quilombola"
        />

        <!-- <form-select
					v-model="item.familia_ribeirinha"
					grid="6"
					label="A família é ribeirinha?"
					:itens="$root.arrays.pergunta"
				/> -->

        <!-- <form-input v-model="item.nome_rio" grid="6" label="Nome do rio" />

				<form-select
					v-model="item.familia_cigana"
					grid="6"
					label="A família é cigana?"
					:itens="$root.arrays.pergunta"
				/>

				<form-input
					v-model="item.nome_comunidade_cigana"
					grid="6"
					label="Nome da comunidade"
				/> -->

        <form-input
          v-model="caracteristicas.qtd_pessoas_domicilio_etnia"
          grid="12"
          label="Quantas pessoas moram no seu domicílio? (Não preencher para famílias em situação de rua e famílias em domicílio coletivo)"
        />

        <form-input
          v-model="caracteristicas.qtd_familias_domicilio_etnia"
          grid="12"
          label="Quantas famílias moram no seu domicílio? (Não preencher para famílias em situação de rua e famílias em domicílio coletivo)"
        />
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <h5 class="font-weight-bold">
            Há alguma pessoa do grupo familiar que está em acolhimento
            institucional ou privada de liberdade há 12 meses ou mais
          </h5>
        </div>
        <form-input
          v-model="caracteristicas.qtd_pessoa_inter_0_17"
          grid="12"
          label="Quantidade de criança(s) e adolescente(s) (de 0 a 17 anos)"
        />

        <form-input
          v-model="caracteristicas.qtd_pessoa_inter_18_64"
          grid="12"
          label="Quantidade de jovem(ns) e adulto(s) (de 18 a 64 anos)"
        />

        <form-input
          v-model="caracteristicas.qtd_pessoa_inter_65"
          grid="12"
          label="Quantidade de pessoa(s) idosa(s) (de 65 anos ou mais)"
        />

      </div>

      <div class="row mt-3">
        <div class="col-md-12">
          <h5 class="font-weight-bold">
            Centro de Referência da Assistência Social (CRAS/CREAS) em que os
            membros da família são atendidos quando necessitam.
          </h5>
        </div>

        <form-input
          v-model="caracteristicas.nome_cras_creas"
          grid="6"
          label="Nome do CRAS/CREAS"
        />

        <form-input
          v-model="caracteristicas.codigo_cras_creas"
          grid="6"
          label="Código do CRAS/CREAS"
        />
      </div>

      <div class="col-md-12 text-right">
        <div class="float-right mt-3">
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      caracteristicas: {
        familia_indigena: null,
        nome_povo_indigena: null,
        indigena_reside: null,
        nome_reserva_indigena: null,
        familia_quilombola: null,
        nome_comunidade_quilombola: null,
        qtd_pessoas_domicilio_etnia: null,
        qtd_familias_domicilio_etnia: null,
        qtd_pessoa_inter_0_17: null,
        qtd_pessoa_inter_18_64: null,
        qtd_pessoa_inter_65: null,
        nome_cras_creas: null,
        codigo_cras_creas: null,
        ind_risco_violacao_direito: null,
      },
      parc_mds: [],
    };
  },
  mounted() {

    if (this.item.caracteristicas != null) {
      this.caracteristicas = this.item.caracteristicas;
    }
    if (this.item.programas_servicos) {
      var input = this.item.programas_servicos.parc_mds;
      if(input != null && typeof input === 'string' && input.split('').length === 3) input = `"${input}"`;

      this.parc_mds = JSON.parse(input);
    }

  },
  methods: {
    submit() {
      this.item.caracteristicas = this.caracteristicas;

      if ( this.parc_mds && this.parc_mds.length != 0 && this.item.programas_servicos != null) {
        this.item.programas_servicos.parc_mds = this.parc_mds;
      } else this.item.programas_servicos = { parc_mds: this.parc_mds };
      
      this.$emit("submit");
    },
  },
};
</script>
